import HTTP from "@/_helpers/http";
import { REGISTERUSERDETAILS__API } from "@/_helpers/urls";
import { REGISTERUSERDETAILS__MUTATIONS } from "../mutation-types";
import { REGISTERUSERDETAILS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
    personalinfo: {},
    clientdeposits: [],
    clientwithdraws: [],
    clientinttrxs: [],
    clientCreditInOuts: [],
    accountTypes: [],
    mt5Accounts: [],
    tradingAcc: [],
    totalDeposits: 0,
    totalDepositAmount: 0,
    totalWithdraws: 0,
    totalWithdrawsAmount: 0,
    totalcreditIn: 0,
    totalcreditOut: 0,
    depositPaymentSystem: [],
    withdrawPaymentSystem: [],
    managers: [],
    userTradingAccounts: [],
    userDemoAccounts: [],
    userDocuments: [],
    brokersbanks: [],
    parentdescendants: null
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [REGISTERUSERDETAILS__MUTATIONS.ACCOUNTDESCENDANTS](state, data) {
        state.parentdescendants = data?.data;
    },
    [REGISTERUSERDETAILS__MUTATIONS.REGPERSONALINFO](state, data) {
        state.personalinfo = data;
    },
    [REGISTERUSERDETAILS__MUTATIONS.CLIENTTRADINGACCOUNTS](state, data) {
        state.tradingAcc = data;
    },
    [REGISTERUSERDETAILS__MUTATIONS.CLIENTDEPOSITS](state, data) {
        state.clientdeposits = data.deposits;
        state.totalDeposits = data.totalDeposits;
        state.totalDepositAmount = data.totalDepositAmount;
    },
    [REGISTERUSERDETAILS__MUTATIONS.CLIENTWITHDRAWS](state, data) {
        state.clientwithdraws = data.withdraws;
        state.totalWithdraws = data.totalWithdraws;
        state.totalWithdrawsAmount = data.totalWithdrawsAmount;
    },
    [REGISTERUSERDETAILS__MUTATIONS.CLIENTINTTRXS](state, data) {
        state.clientinttrxs = data;
    },
    [REGISTERUSERDETAILS__MUTATIONS.CLIENTCREDITINOUT](state, data) {
        state.clientCreditInOuts = data.data;
        state.totalcreditIn = data.creditIn;
        state.totalcreditOut = data.creditOut;
    },
    [REGISTERUSERDETAILS__MUTATIONS.CLIENTMT5ACCOUNTANDTYPES](state, data) {
        state.accountTypes = data.accountTypes;
        state.mt5Accounts = data.mt5Accounts;
    },
    [REGISTERUSERDETAILS__MUTATIONS.PAYMENTSYSTEMFORDEPOSIT](state, data) {
        state.depositPaymentSystem = data;
    },
    [REGISTERUSERDETAILS__MUTATIONS.PAYMENTSYSTEMFORWITHDRAW](state, data) {
        state.withdrawPaymentSystem = data;
    },
    [REGISTERUSERDETAILS__MUTATIONS.GETMANAGERS](state, data) {
        state.managers = data;
    },
    [REGISTERUSERDETAILS__MUTATIONS.USERTRADINGACCOUNTS](state, data) {
        state.userTradingAccounts = data;
    },
    [REGISTERUSERDETAILS__MUTATIONS.USERDEMOACCOUNTS](state, data) {
        state.userDemoAccounts = data;
    },
    [REGISTERUSERDETAILS__MUTATIONS.USERDOCUMENTS](state, data) {
        state.userDocuments = data;
    },
    [REGISTERUSERDETAILS__MUTATIONS.BROKERSBANK](state, data) {
        state.brokersbanks = data;
    },
};
// Actions
const actions = {
    async [REGISTERUSERDETAILS__ACTIONS.ACCOUNTDESCENDANTS]({ commit, state }, id) {
        try {
            const response = await HTTP().get(`${REGISTERUSERDETAILS__API.ACCOUNTDESCENDANTS}/${id}`);

            commit(REGISTERUSERDETAILS__MUTATIONS.ACCOUNTDESCENDANTS, response.data);

        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.BROKERSBANK]({ commit, state }) {
        try {
            const response = await HTTP().get(`${REGISTERUSERDETAILS__API.BROKERSBANK}`);

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.BROKERSBANK, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.USERDOCUMENTS]({ commit, state }, id) {
        try {
            const response = await HTTP().get(`${REGISTERUSERDETAILS__API.USERDOCUMENTS}/${id}`);

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.USERDOCUMENTS, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.USERDEMOACCOUNTS]({ commit, state }, id) {
        try {
            const response = await HTTP().get(`${REGISTERUSERDETAILS__API.USERDEMOACCOUNTS}/${id}`);

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.USERDEMOACCOUNTS, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CREATELIVEACCOUNT]({ dispatch }, data) {
        try {
            const response = await HTTP().post(`${REGISTERUSERDETAILS__API.CREATELIVEACCOUNT}`, data);

            if (response.status === 200) {
                await dispatch(REGISTERUSERDETAILS__ACTIONS.USERTRADINGACCOUNTS, { client_account_id: data.client_account_id });
                toast.success("Created Successfully")
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to create account")
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CREATEDEMOACCOUNT]({ dispatch }, data) {
        try {
            const response = await HTTP().post(`${REGISTERUSERDETAILS__API.CREATEDEMOACCOUNT}`, data);

            if (response.status === 200) {
                await dispatch(REGISTERUSERDETAILS__ACTIONS.USERDEMOACCOUNTS, data.client_account_id);
                toast.success("Created Successfully")
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to create account")
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.USERTRADINGACCOUNTS]({ commit, state }, parameter) {
        try {
            const durationParam =
                parameter?.duration != null ? `duration=${parameter.duration}` : "";

            const idParam =
                parameter?.client_account_id != null ? `client_account_id=${parameter.client_account_id}` : "";

            const parameterString = [
                idParam,
                durationParam,
            ]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                REGISTERUSERDETAILS__API.USERTRADINGACCOUNTS +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.USERTRADINGACCOUNTS, response.data);
            } else {
                commit(REGISTERUSERDETAILS__MUTATIONS.USERTRADINGACCOUNTS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.GETMANAGERS]({ commit, state }, id) {
        try {
            const url = `${REGISTERUSERDETAILS__API.GETMANAGERS}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.GETMANAGERS, response.data);
            } else {
                commit(REGISTERUSERDETAILS__MUTATIONS.GETMANAGERS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.ASSIGNUSER]({ dispatch }, data) {
        try {
            const url = `${REGISTERUSERDETAILS__API.ASSIGNUSER}`;
            const response = await HTTP().patch(url, data);

            if (response.status === 200) {
                await dispatch(REGISTERUSERDETAILS__ACTIONS.GETMANAGERS);
                toast.success(response.data.message)
                return;
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.PAYMENTSYSTEMFORDEPOSIT]({ commit, state }, id) {
        try {
            const url = `${REGISTERUSERDETAILS__API.PAYMENTSYSTEMFORDEPOSIT}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.PAYMENTSYSTEMFORDEPOSIT, response.data);
            } else {
                commit(REGISTERUSERDETAILS__MUTATIONS.PAYMENTSYSTEMFORDEPOSIT, {});
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.PAYMENTSYSTEMFORWITHDRAW]({ commit, state }, id) {
        try {
            const url = `${REGISTERUSERDETAILS__API.PAYMENTSYSTEMFORWITHDRAW}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.PAYMENTSYSTEMFORWITHDRAW, response.data);
            } else {
                commit(REGISTERUSERDETAILS__MUTATIONS.PAYMENTSYSTEMFORWITHDRAW, {});
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO]({ commit, state }, id) {
        try {
            const url = `${REGISTERUSERDETAILS__API.REGPERSONALINFO}/${id}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.REGPERSONALINFO, response.data);
            } else {
                commit(REGISTERUSERDETAILS__MUTATIONS.REGPERSONALINFO, {});
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS]({ commit, state }, id) {
        try {
            const url = `${REGISTERUSERDETAILS__API.CLIENTTRADINGACCOUNTS}/${id}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.CLIENTTRADINGACCOUNTS, response.data);
            } else {
                commit(REGISTERUSERDETAILS__MUTATIONS.CLIENTTRADINGACCOUNTS, {});
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CLIENTMT5ACCOUNTANDTYPES]({ commit, state }, id) {
        try {
            const url = `${REGISTERUSERDETAILS__API.CLIENTMT5ACCOUNTANDTYPES}/${id}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.CLIENTMT5ACCOUNTANDTYPES, response.data);
            } else {
                commit(REGISTERUSERDETAILS__MUTATIONS.CLIENTMT5ACCOUNTANDTYPES, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CHANGECLIENTMT5ACCOUNTANDTYPES]({ commit, state, dispatch }, data) {
        try {
            const url = `${REGISTERUSERDETAILS__API.CHANGECLIENTMT5ACCOUNTANDTYPES}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                toast.success("Updated Successfully")
                await dispatch(REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO, data.userId)
                return;
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CREATECLIENTDEPOSIT]({ commit, state, dispatch }, data) {
        try {
            const url = `${REGISTERUSERDETAILS__API.CREATECLIENTDEPOSIT}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                toast.success("Deposited Successfully")
                await dispatch(REGISTERUSERDETAILS__ACTIONS.CLIENTDEPOSITS, { client_account_id: data.client_account_id })
                return;
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to deposit")
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CREATECLIENTWITHDRAW]({ commit, state, dispatch }, data) {
        try {
            const url = `${REGISTERUSERDETAILS__API.CREATECLIENTWITHDRAW}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                toast.success("Withdrwal Successfull")
                await dispatch(REGISTERUSERDETAILS__ACTIONS.CLIENTWITHDRAWS, { client_account_id: data.client_account_id })
                return;
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to withdraw")
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CHANGECLIENTLEVERAGE]({ commit, state, dispatch }, data) {
        try {
            const url = `${REGISTERUSERDETAILS__API.CHANGECLIENTLEVERAGE}`;
            const response = await HTTP().patch(url, data);

            if (response.status === 200) {
                toast.success("Updated Successfully")
                return;
            }
        } catch (error) {
            console.log(error);
            toast.error("Update failed")
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CHANGECLIENTPASSWORD]({ commit, state, dispatch }, data) {
        try {
            const url = `${REGISTERUSERDETAILS__API.CHANGECLIENTPASSWORD}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                toast.success("Updated Successfully")
                return;
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message)
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CHANGECLIENTLOGINPASSWORD]({ commit, state, dispatch }, data) {
        try {
            const url = `${REGISTERUSERDETAILS__API.CHANGECLIENTLOGINPASSWORD}`;
            const response = await HTTP().patch(url, data);

            if (response.status === 200) {
                toast.success("Updated Successfully")
                return;
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message)
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CLIENTDEPOSITS]({ commit, state }, parameter) {
        try {
            const durationParam =
                parameter?.duration != null ? `duration=${parameter.duration}` : "";

            const statusParam =
                parameter?.status != null ? `status=${parameter.status}` : "";

            const idParam =
                parameter?.client_account_id != null ? `client_account_id=${parameter.client_account_id}` : "";

            const parameterString = [
                idParam,
                statusParam,
                durationParam,
            ]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                REGISTERUSERDETAILS__API.CLIENTDEPOSITS +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.CLIENTDEPOSITS, response.data);
            } else {
                commit(REGISTERUSERDETAILS__MUTATIONS.CLIENTDEPOSITS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CLIENTWITHDRAWS]({ commit, state }, parameter) {
        try {
            const durationParam =
                parameter?.duration != null ? `duration=${parameter.duration}` : "";

            const statusParam =
                parameter?.status != null ? `status=${parameter.status}` : "";

            const idParam =
                parameter?.client_account_id != null ? `client_account_id=${parameter.client_account_id}` : "";

            const parameterString = [
                idParam,
                statusParam,
                durationParam,
            ]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                REGISTERUSERDETAILS__API.CLIENTWITHDRAWS +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.CLIENTWITHDRAWS, response.data);
            } else {
                commit(REGISTERUSERDETAILS__MUTATIONS.CLIENTWITHDRAWS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CLIENTINTTRXS]({ commit, state }, parameter) {
        try {
            const durationParam =
                parameter?.duration != null ? `duration=${parameter.duration}` : "";

            const idParam =
                parameter?.client_account_id != null ? `client_account_id=${parameter.client_account_id}` : "";

            const parameterString = [
                idParam,
                durationParam,
            ]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                REGISTERUSERDETAILS__API.CLIENTINTTRXS +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.CLIENTINTTRXS, response.data);
            } else {
                commit(REGISTERUSERDETAILS__MUTATIONS.CLIENTINTTRXS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CLIENTCREDITINOUT]({ commit, state }, parameter) {
        try {
            const durationParam =
                parameter?.duration != null ? `duration=${parameter.duration}` : "";

            const idParam =
                parameter?.client_account_id != null ? `client_account_id=${parameter.client_account_id}` : "";

            const creditParam =
                parameter?.credit_type != null ? `credit_type=${parameter.credit_type}` : "";

            const parameterString = [
                idParam,
                creditParam,
                durationParam,
            ]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                REGISTERUSERDETAILS__API.CLIENTCREDITINOUT +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            if (response.status === 200) {
                commit(REGISTERUSERDETAILS__MUTATIONS.CLIENTCREDITINOUT, response.data);
            } else {
                commit(REGISTERUSERDETAILS__MUTATIONS.CLIENTCREDITINOUT, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.UPDATEREGPERSONALINFO]({ dispatch, commit, state }, data) {
        try {
            const url = `${REGISTERUSERDETAILS__API.UPDATEREGPERSONALINFO}`;
            const response = await HTTP().patch(url, data);

            if (response.status === 200) {
                await dispatch(REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO, data.id);
                toast.success("Updated successfully")
            }
        } catch (error) {
            console.log(error);
            toast.error("Update Failed")
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CREATECLIENTCREDITINOUT]({ dispatch, commit, state }, data) {
        try {
            const url = `${REGISTERUSERDETAILS__API.CREATECLIENTCREDITINOUT}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                await dispatch(REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO, data.client_account_id);
                await dispatch(REGISTERUSERDETAILS__ACTIONS.CLIENTCREDITINOUT, { client_account_id: data.client_account_id });
                toast.success(response.data.message || "Credit Transfer successfully")
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Credit Transfer Failed")
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.CREATECLIENTINTX]({ dispatch, commit, state }, data) {
        try {
            const url = `${REGISTERUSERDETAILS__API.CREATECLIENTINTX}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                await dispatch(REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO, data.client_account_id);
                await dispatch(REGISTERUSERDETAILS__ACTIONS.CLIENTINTTRXS, { client_account_id: data.client_account_id });
                toast.success(data.message || "Created successfully")
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Create Failed")
        }
    },
    async [REGISTERUSERDETAILS__ACTIONS.UPDATEMT5ACCOUNT]({ dispatch, commit, state }, data) {
        try {
            const url = `${REGISTERUSERDETAILS__API.UPDATEMT5ACCOUNT}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                toast.success(data.message || "Account details updated successfully")
            }
        } catch (error) {
            console.log(error);
            toast.error("Failed to update account details");
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
